"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
var _material = require("@mui/material");
var _timePicker = _interopRequireDefault(require("./timePicker"));
var _dateUtil = _interopRequireDefault(require("../dateUtil"));
var _constants = _interopRequireDefault(require("../constants"));
var _buttonV = _interopRequireDefault(require("../../buttonV2"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// regular expression to match required time format
var REGULAR_EXPECTION_TIME = /^(\d{2}):(\d{2}) ([apAP][mM])?$/;
var TimePickerWrapper = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(TimePickerWrapper, _PureComponent);
  var _super = _createSuper(TimePickerWrapper);
  function TimePickerWrapper(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TimePickerWrapper);
    _this = _super.call(this, props);
    _this.state = {
      invalidTime: false,
      storeDate: props.value
    };
    _this.addHour = _this.addHour.bind((0, _assertThisInitialized2.default)(_this));
    _this.subtractHour = _this.subtractHour.bind((0, _assertThisInitialized2.default)(_this));
    _this.addMinute = _this.addMinute.bind((0, _assertThisInitialized2.default)(_this));
    _this.subtractMinute = _this.subtractMinute.bind((0, _assertThisInitialized2.default)(_this));
    _this.togglePeriod = _this.togglePeriod.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSelectedHour = _this.setSelectedHour.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSelectedMinute = _this.setSelectedMinute.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTyping = _this.handleTyping.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(TimePickerWrapper, [{
    key: "onChange",
    value: function onChange(newDate) {
      var _this2 = this;
      this.setState(function (prevState) {
        var date = (0, _momentTimezone.default)(prevState.storeDate).hour(newDate.hour()).minute(newDate.minute());
        _this2.props.onChange(date);
        return {
          storeDate: date
        };
      });
    }
  }, {
    key: "setSelectedMinute",
    value: function setSelectedMinute(newMinute) {
      this.onChange((0, _momentTimezone.default)(this.props.value).minute(newMinute));
    }
  }, {
    key: "setSelectedHour",
    value: function setSelectedHour(newHour) {
      this.onChange((0, _momentTimezone.default)(this.props.value).hour(newHour));
    }
  }, {
    key: "handleTyping",
    value: function handleTyping(e) {
      var oldDate = this.state.storeDate;
      var value = _lodash.default.trim(e.target.value);
      var regs = value.match(REGULAR_EXPECTION_TIME);
      if (regs && regs[1] > 0 && regs[1] < 13 && regs[2] < 60) {
        var hour = _lodash.default.parseInt(regs[1]);
        if (_lodash.default.upperCase(regs[3]) === 'PM') {
          hour += 12;
        }
        var minute = _lodash.default.parseInt(regs[2]);
        var date = (0, _momentTimezone.default)(oldDate).hour(hour).minute(minute);
        this.onChange(date);
      } else {
        this.setState({
          invalidTime: true
        });
        this.props.onChange(e.target.value);
      }
    }
  }, {
    key: "add",
    value: function add(value, unit) {
      this.onChange((0, _momentTimezone.default)(this.props.value).add(value, unit));
    }
  }, {
    key: "addHour",
    value: function addHour() {
      this.add(1, 'hour');
    }
  }, {
    key: "subtractHour",
    value: function subtractHour() {
      this.add(-1, 'hour');
    }
  }, {
    key: "addMinute",
    value: function addMinute() {
      this.add(1, 'minute');
    }
  }, {
    key: "subtractMinute",
    value: function subtractMinute() {
      this.add(-1, 'minute');
    }
  }, {
    key: "togglePeriod",
    value: function togglePeriod() {
      var value = this.props.value.hour() > 12 ? -12 : 12;
      this.add(value, 'hour');
    }
  }, {
    key: "renderToggleControl",
    value: function renderToggleControl() {
      var value = this.props.value;
      var time = null;
      if ((0, _momentTimezone.default)(value).isValid() && typeof value !== 'string') {
        time = _dateUtil.default.format(value, this.props.format);
      } else if (this.state.invalidTime) {
        time = _lodash.default.get(value, '_i');
      }
      var inputProps = {
        bsRole: 'toggle',
        value: time,
        inputIconClass: 'fa fa-clock-o',
        onFocus: this.openDropDown,
        onChange: this.handleTyping,
        onClick: function onClick() {
          return null;
        },
        name: this.props.name,
        readOnly: this.props.readOnly
      };
      var ToggleControl = this.props.renderInput;
      return /*#__PURE__*/_react.default.createElement(ToggleControl, inputProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        className = _this$props.className;
      var selectedDate = this.state.storeDate;
      if ((0, _momentTimezone.default)(value).isValid() && typeof value !== 'string') {
        selectedDate = value;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        buttonType: "dropdown",
        muiButtonProps: {
          sx: {
            p: 0
          },
          className: 'time-picker-menu',
          title: this.renderToggleControl(),
          endIcon: null
        },
        muiMenuProps: {
          sx: {
            '.MuiList-root': {
              p: 0
            }
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          }
        },
        menuItems: [/*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          disableRipple: true,
          disableGutters: true,
          focusVisibleClassName: "time-picker-dropdown-focused",
          sx: {
            '&:hover': {
              background: 'none'
            },
            cursor: 'default'
          },
          className: "time-picker-dropdown"
        }, /*#__PURE__*/_react.default.createElement(_timePicker.default, {
          selectedDate: selectedDate,
          addHour: this.addHour,
          subtractHour: this.subtractHour,
          addMinute: this.addMinute,
          subtractMinute: this.subtractMinute,
          togglePeriod: this.togglePeriod,
          setSelectedMinute: this.setSelectedMinute,
          setSelectedHour: this.setSelectedHour
        }))]
      }));
    }
  }]);
  return TimePickerWrapper;
}(_react.PureComponent);
TimePickerWrapper.propTypes = {
  value: _propTypes.default.instanceOf(_momentTimezone.default).isRequired,
  onChange: _propTypes.default.func.isRequired,
  format: _propTypes.default.string,
  renderInput: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  name: _propTypes.default.string,
  readOnly: _propTypes.default.bool
};
TimePickerWrapper.defaultProps = {
  format: _constants.default.DateTimeFormat.shortTimeAMPM,
  className: '',
  name: 'timePicker',
  readOnly: true
};
var _default = TimePickerWrapper;
exports.default = _default;